/**
 * Єдиний фронтовий формат ціни: "1 500 грн" (без копійок, NBSP-розділювачі).
 * НЕ для merchant-фіду (server/routes/merchant) — там власний TSV-формат.
 * Математика грошей — functions/src/pricing.mjs, цей модуль лише відображає.
 *
 * СВІДОМО БЕЗ Intl для валюти. Раніше тут стояв
 * `Intl.NumberFormat("uk-UA", { style: "currency", currency: "UAH" })`, і
 * він віддає РІЗНИЙ символ залежно від версії ICU: Node 22 (ICU 77) —
 * "4 500 ₴", Chrome — "4 500 грн". Наслідки були два, і обидва погані:
 * розбіжність гідрації на кожній сторінці з цінами (сервер малює одне,
 * клієнт інше), і краулер бачив ціни інакше, ніж покупці. На третьому
 * браузері міг бути третій варіант.
 *
 * Тому і групування розрядів робиться вручну: воно теж локале-залежне,
 * і покладатись на збіг ICU між рантаймами після такого не варто.
 * "грн" — усталений напис у проєкті (сторінка товару, доставка, чекаут,
 * адмінка пишуть саме так).
 */

const NBSP = " ";

/** Розряди через нерозривний пробіл: 1234567 → "1 234 567". */
function groupDigits(n: number): string {
  return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

export function formatPrice(value: unknown, currency = "UAH"): string {
  const num = Number(value);
  const rounded = Math.round(Number.isFinite(num) ? num : 0);
  const sign = rounded < 0 ? "-" : "";
  const body = `${sign}${groupDigits(Math.abs(rounded))}`;

  const code = String(currency || "UAH").toUpperCase();
  const suffix = code === "UAH" ? "грн" : code;

  return `${body}${NBSP}${suffix}`;
}
